// import React, { createContext, useEffect, ReactNode } from "react";
// import { useSelector } from "react-redux";
// import axios from "../utlils/axios"; // Corrected typo
// import { RootState, useDispatch } from "../store";
// import { loginAction, logoutAction } from "../store/slices/jwtReducer"; // Removed unused changePasswordAction
// import { addUserInfo, clearUserInfo } from '../store/slices/userInfoReducer'; // Ensure correct import
// import { handleSnackbar } from "../utlils/snackbar";


// // ✅ TypeScript interfaces
// interface JWTContextProps {
//   token: string | null;
//   isLoggedIn: boolean;
//   isAdmin?: boolean;
//   login: (
//     email: string,
//     password: string,
//     checked: boolean,
//     key?: string | null
//   ) => Promise<unknown>;
//   logout: () => void;
// }

// interface JWTProviderProps {
//   children: ReactNode;
// }

// interface AuthResponse {
//   userId?: number
//   isLoggedIn: boolean;
//   token: string | null;
//   isAdmin?: boolean
// }

// const setSession = (token: string | null, isAdmin: boolean) => {
//   if (token) {
//     localStorage.setItem("token", token);
//     if (isAdmin) {
//       localStorage.setItem("role", String(isAdmin));
//     }
//   } else {
//     localStorage.removeItem("token");
//     localStorage.removeItem("role");
//   }
// }

// const JWTContext = createContext<JWTContextProps | null>(null);

// export const JWTProvider = ({ children }: JWTProviderProps): React.ReactElement => {
//   const dispatch = useDispatch();
//   const { token, isLoggedIn, isAdmin } =
//     useSelector((state: RootState) => state.jwtState);
//   const { userInfo } = useSelector((state: RootState) => state.userInfoState);
//   // console.log ("isLoggedIn TEST",isLoggedIn)
//   useEffect(() => {
//     console.log("userInfo:", userInfo); // Log userInfo to check its structure
//     if (userInfo?.token) {
//       dispatch(
//         loginAction({
//           token: userInfo.token,
//           isAdmin: userInfo.isAdmin,
//           isLoggedIn: true
//         })
//       );
//     } else {
//       dispatch(logoutAction());
//     }
//   }, [userInfo, dispatch]);


//   const login = async (email: string, password: string, checked: boolean, key: string | null = null): Promise<unknown> => {
//     try {
//       const response = await axios.post<AuthResponse>("/auth/login", {
//         loginName: email,
//         loginPassword: password,
//         rememberMe: checked,
//       });
//       const {
//         token,
//         isAdmin
//       } = response.data;
//       // console.log(response.data); // Log the response data
//       dispatch(addUserInfo(response.data)); // Updated here
//       // console.log('Dispatched addUserInfo action:', response.data); // Log dispatched action
//       dispatch(loginAction(response.data));
//       setSession(token, Boolean(isAdmin));
//       return response;
//     } catch (error) {
//       dispatch(handleSnackbar(error));
//       return error;
//     }
//   };

//   const logout = (): void => {
//     dispatch(clearUserInfo()); // Clear user information
//     dispatch(logoutAction());
//     setSession(null, false);
//   };

//   return (
//     <JWTContext.Provider
//       value={{
//         token,
//         isLoggedIn,
//         isAdmin,
//         login,
//         logout,
//       }}
//     >
//       {children}
//     </JWTContext.Provider>
//   );
// };


// export default JWTContext;

import React, { createContext, ReactNode, useState, useEffect } from "react";
import { useDispatch } from "../store";
import { loginAction, logoutAction } from "../store/slices/jwtReducer";
import { addUserInfo, clearUserInfo } from "../store/slices/userInfoReducer";
import axios from "../utlils/axios";
import { handleSnackbar } from "../utlils/snackbar";

interface JWTContextProps {
  token: string | null;
  isLoggedIn: boolean;
  isAdmin: boolean;
  login: (email: string, password: string, rememberMe: boolean) => Promise<unknown>;
  logout: () => void;
  userId: string | null;
  companyId: string | number | null;
}

interface JWTProviderProps {
  children: ReactNode;
}

interface AuthResponse {
  token: string | null;
  isLoggedIn: boolean;
  isAdmin: boolean;
  userId: number;
  companyId: string | number | null;
}

const JWTContext = createContext<JWTContextProps | null>(null);

export const JWTProvider = ({ children }: JWTProviderProps) => {
  const dispatch = useDispatch();

  // reactive state
  const [token, setToken] = useState<string | null>(localStorage.getItem("token"));
  const [isAdmin, setIsAdmin] = useState(localStorage.getItem("role") === "true");
  const [userId, setUserId] = useState<string | null>(localStorage.getItem("userId"));
  const [isLoggedIn, setIsLoggedIn] = useState(!!token);
  const [companyId, setCompanyId] = useState<string | number | null>(null);

  useEffect(() => {
    if (token) {
      dispatch(loginAction({ token, isAdmin, isLoggedIn: true }));
    } else {
      dispatch(logoutAction());
      dispatch(clearUserInfo());
    }
  }, []);

  //   useEffect(() => {
  //   if (token) {
  //     dispatch(loginAction({ token, isAdmin, isLoggedIn: true }));
  //   } else {
  //     dispatch(logoutAction());
  //     dispatch(clearUserInfo());
  //   }
  // }, [token, isAdmin, isLoggedIn, dispatch]);

  const login = async (email: string, password: string, rememberMe: boolean) => {
    try {
      const response = await axios.post<AuthResponse>("/auth/login", {
        loginName: email,
        loginPassword: password,
        rememberMe,
      });

      const { token, isAdmin, userId, companyId } = response.data;

      // Save to localStorage
      if (token) {
        localStorage.setItem("token", token);
        localStorage.setItem("userId", String(userId));
        localStorage.setItem("role", String(Boolean(isAdmin)));
      }

      setToken(token);
      setIsAdmin(Boolean(isAdmin));
      setIsLoggedIn(!!token);
      setUserId(String(userId))
      setCompanyId(companyId);

      dispatch(addUserInfo(response.data));
      dispatch(loginAction({ token, isAdmin, isLoggedIn: true }));

      return response;
    } catch (error) {
      dispatch(handleSnackbar(error));
      return error;
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("isAdmin");
    localStorage.removeItem("userId");

    setToken(null);
    setIsAdmin(false);
    setIsLoggedIn(false);
    setUserId(null);
    setCompanyId(null);

    dispatch(clearUserInfo());
    dispatch(logoutAction());
  };

  return (
    <JWTContext.Provider value={{ token, isLoggedIn, isAdmin, login, logout, userId, companyId }}>
      {children}
    </JWTContext.Provider>
  );
};

export default JWTContext;
